<template>
  <v-dialog v-model="show" max-width="350" persistent>
    <v-card>
      <v-card-title class="text-h5"> Proteus PACS </v-card-title>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t("Name") }}</th>
                <th class="text-left">{{ $t("Version") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="font-weight-bold" v-if="item.name==='proteusd'">{{ item.name }}</td>
                <td v-else>{{ item.name }}</td>

                <td class="font-weight-bold" v-if="item.name==='proteusd'">{{ item.version }}</td>
                <td v-else>{{ item.version }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primaryLigth" text @click="$emit('onClose')">
          {{ $t("Close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "InfoModal",
  data() {
    return {
      show: true,
      items: {},
    };
  },
  created() {
    axios({ url: "/versions.json", method: "GET" })
      .then((response) => {
        this.items = response.data;
      })
      .catch((error) => {
        this.sendError(error);
      });
  },
};
</script>

<style scoped>
</style>